import { CUSTOM_VEHICLE_MAKE_ID, CUSTOM_VEHICLE_MODEL_ID } from '../../common/constants';

export function getVehicleYearOptions() {
  const years = [];
  const currentYear = (new Date()).getFullYear();
  for (let year = currentYear + 1; year > 1949; year -= 1) {
    years.push({ label: `${year}`, value: year });
  }
  return years;
}

export function getMakeOrModelOptions(items) {
  if (!items || !items.length) {
    return [];
  }
  return items.map(item => ({
    label: item.name,
    value: item.id,
  }));
}

export function getOptionLabelByValue(options, value) {
  const optionFound = options?.find(option => option.value.toString() === value.toString());
  return optionFound?.label;
}

export function areVehicleProfilesSame(profileA, profileB) {
  const {
    guid,
    specs: { year, make, model },
    nickname,
    imageUrl,
  } = profileA;

  return (
    guid === profileB.guid
    && year === profileB.specs.year
    && make === profileB.specs.make
    && model === profileB.specs.model
    && nickname === profileB.nickname
    && imageUrl === profileB.imageUrl
  );
}

export function getRecallKey(year, make, model) {
  return escape(`${year}_${make}_${model}`.toLowerCase());
}

export function getModelsKey(keyObj) {
  const { year, makeId } = keyObj;
  return `${year}_${makeId}`;
}

export function setModelsToMap(keyObj, models, modelsMap) {
  modelsMap[getModelsKey(keyObj)] = models;
}

export function getModelsFromMap(keyObj, modelsMap) {
  return (keyObj?.year && keyObj?.makeId && modelsMap) ? modelsMap[getModelsKey(keyObj)] : [];
}

export function isCustomMakeId(makeId) {
  return makeId === CUSTOM_VEHICLE_MAKE_ID;
}

export function isCustomModelId(modelId) {
  return modelId === CUSTOM_VEHICLE_MODEL_ID;
}
